export default __webpack_public_path__ + "assembly1079e6b9.png";